import React from 'react';

/**
 * A member of the circle, as a face rather than a token.
 *
 * The Commons has MemberToken — a card with a number on it, because members
 * are numbers to each other there. This is its opposite and deliberately looks
 * nothing like it: a circle of initials, which is what an application shows
 * when it knows who somebody is.
 *
 * Two shapes, two rooms, and no component shared between them. The same
 * reasoning as sworn_identity.py being a separate module: a control that can
 * be pointed at the wrong room is a control that eventually will be. If these
 * were one component with a prop, the prop could be wrong.
 *
 * See docs/sworn_design.md §4 and §5.
 */

const initialsOf = (display) => {
  const parts = String(display || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '·';
  // First and last, so "Martin Engelbrecht" reads ME and a single name reads
  // as one letter rather than two of the same.
  const first = parts[0][0];
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
};

const SwornFace = ({ display, size = 'sm', muted = false }) => {
  const big = size === 'lg';
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full border border-border ${
        big ? 'w-12 h-12 text-sm' : 'w-9 h-9 text-xs'
      } ${muted ? 'bg-muted/40 text-muted-foreground' : 'bg-muted text-foreground'}`}
      title={display || undefined}
      aria-hidden="true"
    >
      <span className="font-heading leading-none">{initialsOf(display)}</span>
    </span>
  );
};

export default SwornFace;
